import { render, staticRenderFns } from "./PlatformWalletsHistory.vue?vue&type=template&id=1b076860&"
import script from "./PlatformWalletsHistory.vue?vue&type=script&lang=js&"
export * from "./PlatformWalletsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports